<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">お気に入り登録</span>
          </div>
        </header>
        <div class="card-content scroll-box">
          <!-- カレンダー連携 -->
          <div class="message disp-scroll">
            <b-tabs style="background: white;">
              <b-tab-item label="基本設定" class="tab-box disp-scroll">
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>お気に入り登録名</b>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <b-input style="width: 100%;" placeholder="何も入力しない場合には仮枠と登録されます" v-model="name" max-length="100"></b-input>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>タイトル</b>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <b-input style="width: 100%;" placeholder="何も入力しない場合には仮枠と登録されます" v-model="info.title" max-length="100"></b-input>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p><b>予定時間</b></p>
                  </div>
                  <div class="tab-box-right">
                    <p style="display: flex; align-items: center;">
                      <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="1" min="0" max="23" v-model="info.mtg_time_hour" controls-position="compact"></b-numberinput>
                      <span style="margin-left: 4px;">時間</span>
                    </p>
                    <p style="display: flex; align-items: center; margin-left: 16px;">
                      <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="15" min="0" max="45" v-model="info.mtg_time_minute" controls-position="compact"></b-numberinput>
                      <span style="margin-left: 4px;">分</span>
                    </p>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p><b><!--設定しない曜日-->休日</b></p>
                  </div>
                  <div class="tab-box-right">
                    <b-checkbox v-for="(ch, idx) in weekdayList" :key="idx" v-model="info.holiday_list"
                      :native-value="idx">
                      {{ch}}
                    </b-checkbox>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p><b><!--設定しない曜日-->祝日</b></p>
                  </div>
                  <div class="tab-box-right">
                    <b-switch style="width: 100%;" size="is-small" v-model="info.public_holiday">
                    </b-switch>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p><b>調整可能時間帯</b></p>
                  </div>
                  <div class="tab-box-right">
                    <b-timepicker v-model="start" size="is-small" inline></b-timepicker>
                    <p style="font-size: 24px;margin-left:10px;margin-right:10px;"><b>-</b></p>
                    <b-timepicker v-model="end" size="is-small" inline></b-timepicker>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>日程調整開始日</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">現在から何日後か入力します</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <p style="display: flex; align-items: center;">
                      <b-numberinput size="is-small" style="width: 100px;" v-model="info.after" :editable="false" min="1" max="10" controls-position="compact"></b-numberinput>
                      <span style="margin-left: 4px;">日後</span>
                    </p>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left" style="flex-wrap: wrap;">
                    <p><b>メモ</b></p>
                    <br>
                    <span style="text-align: left; color: #666; font-size: 12px;">日程調整をした日の予定に入れるメモ欄です。</span>
                  </div>
                  <div class="tab-box-right">
                    <textarea class="input textarea" v-model="info.memo" maxlength="200"></textarea>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left" style="flex-wrap: wrap;">
                    <p style="text-align: left;">
                      <b>必須参加者</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">最低1人以上お選びください</span>
                    </p>
                  </div>
                  <div class="tab-box-right" style="flex-wrap: wrap;">
                    <b-checkbox v-for="(u, idx) in users" :key="idx" v-model="info.user_hash" style="margin: 5px;"
                      :native-value="u.user_hash">
                      {{u.username}}
                    </b-checkbox>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left" style="flex-wrap: wrap;">
                    <p style="text-align: left;">
                      <b>任意参加者</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">選択した中から1人が選ばれます</span>
                    </p>
                  </div>
                  <div class="tab-box-right" style="flex-wrap: wrap;">
                    <b-checkbox v-for="(us, idx2) in users" :key="idx2" v-model="info.user_hash_sub" style="margin: 5px;"
                      :native-value="us.user_hash"
                      v-if="isCheck(us.user_hash, 0)">
                      {{us.username}}
                    </b-checkbox>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p><b>共有者</b></p>
                  </div>
                  <div class="tab-box-right" style="flex-wrap: wrap;">
                    <b-checkbox v-for="(us, idx3) in users" :key="idx3" v-model="info.user_hash_share" style="margin: 5px;"
                      :native-value="us.user_hash"
                      v-if="isCheck(us.user_hash, 1)">
                      {{us.username}}
                    </b-checkbox>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left" style="flex-wrap: wrap;">
                    <p><b>候補確定方法</b></p>
                    <br>
                    <span style="text-align: left; color: #666; font-size: 12px;">候補を上げた際の確定方法をお選びください。</span>
                  </div>
                  <div class="tab-box-right">
                    <select class="select" v-model="info.method">
                      <option value="0">自分で候補日時を選択する方法</option>
                      <option value="1">複数候補から相手に同意を得る方法</option>
                    </select>
                    <template v-if="info.method">
                      <p v-if="info.method === 0">自分で空いている候補日時を一つ選択し、参加者に通知する方法です。</p>
                      <p v-if="info.method === 1">複数候補日時を参加者に通知し、選んでいただく方法です。(任意参加者・共有者は候補日を選ぶことができません。)</p>
                    </template>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>バッファ</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">予定間の空き時間を入力します</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <p style="display: flex; align-items: center;">
                      <b-numberinput size="is-small" style="width: 100px;" step="15" :editable="false" v-model="info.interval" min="0" max="120" controls-position="compact"></b-numberinput>
                      <span style="margin-left: 4px;">分</span>
                    </p>
                  </div>
                </div>
              </b-tab-item>
              <b-tab-item label="リマインダー設定" class="tab-box disp-scroll">
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>リマインダー通知</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">ONにすると設定したメールが届きます</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <b-switch style="width: 100%;" v-model="info.reminder_flg">切替</b-switch>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>リマインダー通知日</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">日程調整をした日の何日前に送るか設定します</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <p style="display: flex; align-items: center;">
                      <b-numberinput v-model="info.reminder_day" :editable="false" min="1" max="10" style="width: 100px;" size="is-small" controls-position="compact" :disabled="!info.reminder_flg"></b-numberinput>
                      <span style="margin-left: 4px;">日前</span>
                    </p>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>直前リマインダー通知</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">ONにすると登録された予定時間の直前に再度メールが届きます<br/>※30分〜120分前の間で設定可能です</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <b-switch style="width: 40%;" v-model="info.reminder_before_flg" :disabled="!info.reminder_flg">切替</b-switch>
                    <p style="display: flex; align-items: center;">
                      <b-numberinput style="width: 100px;" size="is-small" :editable="false" step="10" min="30" max="120" v-model="info.reminder_before_minute" controls-position="compact" :disabled="!info.reminder_flg||!info.reminder_before_flg"></b-numberinput>
                      <span style="margin-left: 4px;">分前</span>
                    </p>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>メンバーにも送付</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">ONにすると基本設定で選択したメンバーおよびユーザーにもメールが届きます</span>
                    </p>
                  </div>
                  <div class="tab-box-right">
                    <b-switch style="width: 100%;" v-model="info.reminder_member_flg" :disabled="!info.reminder_flg">切替</b-switch>
                  </div>
                </div>
                <div class="dot-line"></div>
                <div class="tab-box-form">
                  <div class="tab-box-left">
                    <p style="text-align: left;">
                      <b>メール内容</b>
                      <br>
                      <span style="color: #666; font-size: 12px;">リマインダーメールの内容を設定できます</span>
                      <br>
                      <span style="color: #666; font-size: 12px;">メールはHRモンスター（noreply@hr-monster.io）からお送りいたします。</span>
                    </p>
                  </div>
                  <div class="tab-box-right" style="flex-wrap: wrap;">
                    <p style="width: 100%; text-align: left;font-weight: bold;">件名</p>
                    <b-input style="width: 100%;" placeholder="例：件名を入力" v-model="info.reminder_title" :disabled="!info.reminder_flg"></b-input>
                    <hr>
                    <p style="width: 100%; text-align: left;font-weight: bold;">TO（カンマ区切りで追加できます。）</p>
                    <b-input style="width: 100%;" placeholder="例：TOを入力" v-model="info.reminder_to" :disabled="!info.reminder_flg"></b-input>
                    <hr>
                    <p style="width: 100%; text-align: left;font-weight: bold;">CC（カンマ区切りで追加できます。）</p>
                    <b-input style="width: 100%;" placeholder="例：CCを入力" v-model="info.reminder_cc" :disabled="!info.reminder_flg"></b-input>
                    <hr>
                    <p style="width: 100%; text-align: left; font-weight: bold;">メールの内容を入力してください。</p>
                    <div style="width: 100%; height: auto;">
                      <quill-editor v-model="info.reminder_content" ref="quillEditor" :options="optionsRemainder" :disabled="!info.reminder_flg"></quill-editor>
                    </div>
                  </div>
                </div>
              </b-tab-item>
            </b-tabs>
          </div>
          <b-field style="width: 100%">
            <div style="width: 48%; align: left">
              <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                キャンセル
              </button>
            </div>
            <div style="width: 5%;">
            </div>
            <div style="width: 48%; align: right">
              <button class="button is-primary is-fullwidth" @click="clickSaveCalendarBookMark(); closeEditPage();">
                登録
              </button>
            </div>
          </b-field>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalCalendarBookMark',
  computed: {
    ...mapState('auth', ['user', 'users', 'departments', 'positions']),
    ...mapState('calendar', ['recommendDate', 'isErrorRecommendSchedule', 'preserveSuggestedSchedulesList', 'isRecommendSchedule']),
    filteredUsers () {
      let retUsers = []
      for (const u of this.users) {
        if (u.is_google_calendar_auth && u.google_calendar_param) {
          retUsers.push({
            name: u.username,
            param: u.google_calendar_param,
            isAuth: u.is_google_calendar_auth
          })
        } else if (u.is_garoon_auth && u.garoon_param) {
          retUsers.push({
            name: u.username,
            param: u.garoon_param,
            isAuth: u.is_garoon_auth
          })
        } else if (u.is_cybozu_office_auth && u.cybozu_office_param) {
          retUsers.push({
            name: u.username,
            param: u.cybozu_office_param,
            isAuth: u.is_cybozu_office_auth
          })
          return u.cybozu_office_param
        } else if (u.is_msoffice_auth && u.ms_office_param) {
          retUsers.push({
            name: u.username,
            param: u.ms_office_param,
            isAuth: u.is_msoffice_auth
          })
        }
      }
      return retUsers
    }
  },
  data () {
    return {
      name: null,
      info: null,
      isCardModalActive: false,
      start: new Date(2000, 1, 1, 9, 0),
      end: new Date(2000, 1, 1, 18, 0),
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ],
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      optionsRemainder: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
    }
  },
  methods: {
    isCheck (hash, type) {
      for (var u in this.info.user_hash) {
        if (this.info.user_hash[u] == hash) return false
      }
      if (type > 0) {
        for (var u in this.info.user_hash_sub) {
          if (this.info.user_hash_sub[u] == hash) return false
        }
      }
      return true
    },
    clickSaveCalendarBookMark () {
      let param = this.info
      param.mtg_time = 1
      param.count = 3
      param.no_candidate = ''
      param.until = 60
      param.company_hash = this.user.companyID
      let start_hour = this.start.getHours()
      let start_minute = this.start.getMinutes()
      let end_hour = this.end.getHours()
      let end_minute = this.end.getMinutes()
      param.work_time_start = parseFloat(start_hour + (start_minute / 100))
      param.work_time_end = parseFloat(end_hour + (end_minute / 100))
      let tempCalendarBookMark = {
        name: this.name ? this.name : this.getUserName(this.info.user_hash),
        parameter: param,
        user: this.user.userHash
      }
      this.$store.dispatch('auth/createCalendarBookMark', tempCalendarBookMark)
      this.isCardModalActive = false
    },
    closeEditPage () {
      this.isCardModalActive = false
    },
    getUserName (user_hash) {
      let retStr = ''
      let filteredUsers = user_hash.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
      for (const u of this.users) {
        for (const u2 of filteredUsers) {
          if (u.user_hash === u2) {
            retStr += u.username + ' '
          }
        }
      }
      return retStr
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
.btn-default-color{
  background: #f8f8f8;
}
.on_switch {
  background: #EE2C98;
  color: #ffffff;
}
.message {
  background: white;
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  padding: 16px;
  margin-top: 16px;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 30%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 70%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
.select_container {
  height: 272px;
  overflow: auto;
  border: 1px solid #dbdbdb;
  margin-bottom: 6px;
  border-radius: 3px;
}
.select_container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.description {
  font-size: 14px;
}
.select_list {
  margin: 16px 0 16px 32px;
  display: flex;
  align-items: center;
}
.patern_num {
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.ConnectingWord {
  font-size: 14px;
  margin: 6px;
}
.input_point {
  width: 64px;
}
.if_select {
  margin: 16px;
}
.close-wrapper {
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  margin-left: 16px;
  &:hover {
    opacity: 1;
    color: red;
  }
  .mdi-close {
    &:before {
      font-weight: bold;
    }
  }
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  top: 64px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  overflow: auto;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
.quote-list-wrapper {
  overflow-y: scroll;
  margin: 8px;
}
.quote-list-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;

}
.open-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.open-quote-btn {
  cursor: pointer;
}
.quote-list-content {
  table {
    margin: auto;
    font-size: 12px;
  }
  table th {
    padding: 4px;
  }
  table td {
    padding: 4px;
  }
}
.table-container {
  overflow-y: scroll;
}
.table-container::-webkit-scrollbar {
  width: 10px;
  height: 0px;
  visibility: hidden;
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.not-find-quote {
  font-size: 12px;
}
.quote-explain {
  font-size: 12px;
  margin-bottom: 16px;
}
.close-btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalCalendarBookMark.vue